module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAKhJREFUWEftlMENAyEMBHc7SylJZcl1klTmyFJOQgTuFn/us3wx9jA2EBcvXlwfBrABG7ABG5ANRMSN5Fv5uldiJYCIuAN4AniRfBxBrMRmnlWAPDOFaIpn3EYywQ+XBJAZuuR/EJXisoH9CjOIavFlgJEJAJ/ffMja257ILWgPdTfet6Se9wNRAhiYKBUvtWBgIv+H02mfPYWygbPnpe4bwAZswAZs4AvqNkUhKYxvuQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/community/angle-down.png
// module id = estG
// module chunks = 15